/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationDataSetDto } from './EnumerationDataSetDto';
import {
    instanceOfEnumerationDataSetDto,
    EnumerationDataSetDtoFromJSON,
    EnumerationDataSetDtoFromJSONTyped,
    EnumerationDataSetDtoToJSON,
} from './EnumerationDataSetDto';
import type { NumericDataSetDto } from './NumericDataSetDto';
import {
    instanceOfNumericDataSetDto,
    NumericDataSetDtoFromJSON,
    NumericDataSetDtoFromJSONTyped,
    NumericDataSetDtoToJSON,
} from './NumericDataSetDto';

/**
 * @type DataSetDto
 * 
 * @export
 */
export type DataSetDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationDataSetDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericDataSetDto;


export function DataSetDtoFromJSON(json: any): DataSetDto {
    return DataSetDtoFromJSONTyped(json, false);
}

export function DataSetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSetDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationDataSetDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericDataSetDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of DataSetDto exists with '$type=${json['$type']}'`);
    }
}

export function DataSetDtoToJSON(value?: DataSetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationDataSetDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericDataSetDtoToJSON(value);
        default:
            throw new Error(`No variant of DataSetDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the DataSetDto interface.
 */
export function instanceOfDataSetDto(value: any): value is DataSetDto {
    if (instanceOfEnumerationDataSetDto(value)) return true;
    if (instanceOfNumericDataSetDto(value)) return true;
    return false;
}

